import { useState } from "react";
import { useRef } from "react";
import {
  createCustomer,
  findCustomerByPhone,
} from "../../../../../services/CustomerService";
import { toast } from "react-toastify";
import { ModalBody, ModalFooter } from "reactstrap";
import removerSpecialChars from "../../../../../util/StringUtils";
import ReactInputMask from "react-input-mask";
import carBrands from "../../../../../consts/CarBrands";
import ReactSelect from "react-select";

const FormVehicleAndCustomer = (props) => {
  const [inputPhone, setInputPhone] = useState("");
  const [inputName, setInputName] = useState("");
  const [inputAddress, setInputAddress] = useState("");
  const addButton = useRef("");
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(true);
  const [vehicleBrand, setVehicleBrand] = useState();
  const [inputLicensePlate, setInputLicensePlate] = useState(
    props.licensePlate,
  );
  const [inputVehicleColor, setInputVehicleColor] = useState("");
  const [inputVehicleModel, setInputVehicleModel] = useState("");
  const regexLicensePlate = "^.{7}$";

  function findByPhone() {
    findCustomerByPhone("55" + removerSpecialChars(inputPhone))
      .then((response) => {
        if (response) {
          setInputName(response.name);
          setInputAddress(response.address);
          addButton.current.disabled = true;
          toast.warning(
            "Cliente já cadastrado. Escolha a opção somente veículo no incio deste formulário",
          );
        } else {
          addButton.current.disabled = false;
          inputName.current.value = "";
          inputAddress.current.value = "";
        }
      })
      .catch((error) => { });
  }

  function handleSubmitVehicleAndCustomerForm(e) {
    setLoading(true);
    e.preventDefault();

    const data = {
      phone: "55" + removerSpecialChars(inputPhone),
      name: inputName,
      address: inputAddress,
      notify,
      vehicle: {
        vehicleModel: inputVehicleModel,
        vehicleBrand: vehicleBrand.key,
        licensePlate: inputLicensePlate,
        vehicleColor: inputVehicleColor,
      },
    };

    createCustomer(data)
      .then((response) => {
        toast.success("Cliente e Veículo cadastrado");
        props.findVehicle(data.vehicle.licensePlate);
        setLoading(false);
        props.close();
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status)
          toast.error(error.response.data);
        else toast.error("Não foi possivel cadastrar cliente");
      });
  }

  return (
    <form onSubmit={handleSubmitVehicleAndCustomerForm} className="w-100">
      {/* SEÇÃO 1: DADOS DO VEÍCULO */}
      <div className="bg-light p-3 rounded-4 border w-100 mt-2">
        <div className="d-flex align-items-center mb-3 text-primary">
          <i className="fas fa-car me-2"></i>
          <span className="fw-bold text-muted small text-uppercase">Informações do Veículo</span>
        </div>

        <div className="row g-2">
          <div className="col-lg-3">
            <label className="form-label small fw-bold text-dark">Placa <span className="text-danger">*</span></label>
            <input
              onChange={(e) => setInputLicensePlate(e.target.value)}
              value={inputLicensePlate}
              className="form-control form-control-lg fw-bold text-uppercase border-2 bg-white"
              style={{ letterSpacing: '2px' }}
              pattern={regexLicensePlate}
              maxLength={7}
              placeholder="Ex: ABC1D23"
              required
            />
          </div>
          <div className="col-lg-3">
            <label className="form-label small fw-bold text-dark">Marca <span className="text-danger">*</span></label>
            <ReactSelect
              id="selectBrand"
              name="brands"
              classNamePrefix="select"
              onChange={(brand) => setVehicleBrand(brand)}
              value={vehicleBrand}
              options={carBrands.map((brand, index) => ({
                value: brand.replace("_", " "),
                key: brand,
                label: brand.replace("_", " "),
              }))}
              placeholder="Marca..."
              required
              styles={{ control: (b) => ({ ...b, borderRadius: '8px', minHeight: '48px' }) }}
            />
          </div>
          <div className="col-lg-3">
            <label className="form-label small fw-bold text-dark">Modelo <span className="text-danger">*</span></label>
            <input
              id="carModel"
              onChange={(e) => setInputVehicleModel(e.target.value)}
              value={inputVehicleModel}
              type="text"
              className="form-control form-control-lg fs-6 border-2"
              placeholder="Ex: Gol"
              required
            />
          </div>
          <div className="col-lg-3">
            <label className="form-label small fw-bold text-dark">Cor</label>
            <input
              onChange={(e) => setInputVehicleColor(e.target.value)}
              value={inputVehicleColor}
              className="form-control form-control-lg fs-6 border-2"
              placeholder="Ex: Preto"
            />
          </div>
        </div>
      </div>

      {/* SEÇÃO 2: DADOS DO CLIENTE */}
      <div className="bg-white p-3 rounded-4 border w-100 mt-4 shadow-sm">
        <div className="d-flex align-items-center mb-3 text-primary">
          <i className="fas fa-user me-2"></i>
          <span className="fw-bold text-muted small text-uppercase">Informações do Cliente</span>
        </div>

        <div className="row g-3">
          <div className="col-lg-4">
            <label className="form-label small fw-bold text-dark">Telefone <span className="text-danger">*</span></label>
            <ReactInputMask
              value={inputPhone}
              onChange={(e) => setInputPhone(e.target.value)}
              mask="(99) 99999-9999"
              inputMode="numeric"
              onBlur={findByPhone}
              id="customerPhone"
              className="form-control form-control-lg fw-bold text-primary border-2"
              placeholder="(00) 00000-0000"
              required
            />
          </div>

          <div className="col-lg-5">
            <label className="form-label small fw-bold text-dark">Nome <span className="text-danger">*</span></label>
            <input
              value={inputName}
              onChange={(e) => setInputName(e.target.value)}
              type="text"
              id="customerName"
              className="form-control form-control-lg fs-6 border-2"
              placeholder="Nome completo"
              required
            />
          </div>

          <div className="col-lg-3 d-flex flex-column justify-content-center align-items-center border-start">
            <label className="form-label small fw-bold text-dark mb-2 text-center">Notificar WhatsApp</label>
            <div className="form-check form-switch m-0">
              <input
                className="form-check-input cursor-pointer shadow-none"
                style={{ width: '2.5rem', height: '1.25rem' }}
                type="checkbox"
                id="switchNotify"
                checked={notify}
                onChange={() => setNotify(!notify)}
              />
            </div>
            <small className={`fw-bold mt-1 ${notify ? 'text-success' : 'text-danger'}`} style={{ fontSize: '0.7rem' }}>
              {notify ? "ATIVADO" : "DESATIVADO"}
            </small>
          </div>

          <div className="col-lg-12">
            <label className="form-label small fw-bold text-dark">Endereço <span className="text-muted fw-normal">(opcional)</span></label>
            <input
              value={inputAddress}
              onChange={(e) => setInputAddress(e.target.value)}
              type="text"
              id="address"
              className="form-control rounded-3 border-2"
              placeholder="Rua, número, bairro..."
            />
          </div>
        </div>
      </div>

      {/* FOOTER MANUAL (SEM MODALFOOTER PARA EVITAR DESALINHAMENTO) */}
      <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end mt-4 px-1">
        {!loading ? (
          <>
            <button
              ref={addButton}
              type="submit"
              className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm order-0 px-sm-5"
              style={{ minWidth: '180px' }}
            >
              <i className="fas fa-user-check me-2"></i> Salvar Cadastro
            </button>

            <button
              type="button"
              onClick={() => props.close()}
              className="btn btn-outline-danger btn-lg rounded-3 border-2 order-1"
            >
              Cancelar
            </button>
          </>
        ) : (
          <div className="w-100 text-center py-2">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        )}
      </div>
    </form>
  );
};
export default FormVehicleAndCustomer;
